import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { WorkflowAdministrationLayer } from '../../transportLayers/workflow/WorkflowAdministrationLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { List } from 'immutable';
/**
 * This store obtaining data of price competitors.
 */

export var WorkflowAdministrationStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(WorkflowAdministrationStore, _BaseStore);

  function WorkflowAdministrationStore() {
    var _this;

    _classCallCheck(this, WorkflowAdministrationStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowAdministrationStore).apply(this, arguments));
    _this.name = StoreName.WorkflowAdministration;
    _this.workflowCaseInfoLayer = new WorkflowAdministrationLayer();
    _this.caseDefinitions = new Map();
    _this.cases = new Map();
    _this.locks = new Map();
    return _this;
  }

  _createClass(WorkflowAdministrationStore, [{
    key: "getWorkflowCaseDefinitions",
    value: function getWorkflowCaseDefinitions() {
      var _this2 = this;

      this.cases.clear();
      return this.workflowCaseInfoLayer.getWorkflowCaseDefinitions().then(function (casesDefinitions) {
        runInAction(function () {
          casesDefinitions.forEach(function (casesDefinition) {
            if (casesDefinition.id) {
              _this2.caseDefinitions.set(casesDefinition.id, casesDefinition);
            }
          });
        });
        return casesDefinitions;
      });
    }
  }, {
    key: "getWorkflowCases",
    value: function getWorkflowCases(criteria) {
      var _this3 = this;

      this.cases.clear();
      return this.workflowCaseInfoLayer.getWorkflowCases(criteria).then(function (cases) {
        runInAction(function () {
          cases.forEach(function (workflowCaseInfo) {
            if (workflowCaseInfo.id) {
              _this3.cases.set(workflowCaseInfo.id, workflowCaseInfo);
            }
          });
        });
        return cases;
      });
    }
  }, {
    key: "terminateCases",
    value: function terminateCases(caseIds) {
      var _this4 = this;

      return this.workflowCaseInfoLayer.terminateCases(caseIds).then(function (cases) {
        runInAction(function () {
          cases.forEach(function (workflowCaseInfo) {
            if (workflowCaseInfo.id) {
              _this4.cases.set(workflowCaseInfo.id, workflowCaseInfo);
            }
          });
        });
        return cases;
      });
    }
  }, {
    key: "abandonCases",
    value: function abandonCases(caseIds) {
      var _this5 = this;

      return this.workflowCaseInfoLayer.abandonCases(caseIds).then(function (cases) {
        runInAction(function () {
          cases.forEach(function (workflowCaseInfo) {
            if (workflowCaseInfo.id) {
              // this.cases.set(workflowCaseInfo.id, workflowCaseInfo);
              _this5.cases.delete(workflowCaseInfo.id);
            }
          });
        });
        return cases;
      });
    }
  }, {
    key: "getLocks",
    value: function getLocks(criteria) {
      var _this6 = this;

      return this.workflowCaseInfoLayer.getLocks(criteria).then(function (locks) {
        runInAction(function () {
          locks.forEach(function (lock) {
            if (lock.id) {
              _this6.locks.set(lock.id, lock);
            }
          });
        });
        return locks;
      });
    }
  }, {
    key: "unlock",
    value: function unlock(locksInfo) {
      var _this7 = this;

      return this.workflowCaseInfoLayer.unlock(locksInfo).then(function (unlocked) {
        runInAction(function () {
          unlocked.forEach(function (lockId) {
            _this7.locks.delete(lockId);
          });
        });
        return unlocked;
      });
    }
  }]);

  return WorkflowAdministrationStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], WorkflowAdministrationStore.prototype, "caseDefinitions", void 0);

__decorate([observable, __metadata("design:type", Map)], WorkflowAdministrationStore.prototype, "cases", void 0);

__decorate([observable, __metadata("design:type", Map)], WorkflowAdministrationStore.prototype, "locks", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], WorkflowAdministrationStore.prototype, "getWorkflowCaseDefinitions", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], WorkflowAdministrationStore.prototype, "getWorkflowCases", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], WorkflowAdministrationStore.prototype, "terminateCases", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], WorkflowAdministrationStore.prototype, "abandonCases", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], WorkflowAdministrationStore.prototype, "getLocks", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", void 0)], WorkflowAdministrationStore.prototype, "unlock", null);